export const promiseSequence = async (callbackArray) => {
  const values = []
  const visit = async (index) => {
    if (index === callbackArray.length) return
    const callback = callbackArray[index]
    const value = await callback()
    values.push(value)
    await visit(index + 1)
  }
  await visit(0)
  return values
}
